import React, { useState, useContext, useEffect } from "react";
import clsx from "clsx";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import StarBorder from "@material-ui/icons/StarBorder";
import Star from "@material-ui/icons/Star";
import MoreHoriz from "@material-ui/icons/MoreHoriz";
import Info from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import { useTranslation } from "react-i18next";
import Tooltip from "@material-ui/core/Tooltip";
import GlobalContext from "../../lib/GlobalContext";
import { MESSAGE_TYPES } from "../PopupMessages";
import GoogleMapComponent from "../../lib/GoogleMapComponent";
import withAccessControl from "../HOC/AccessControl";
import GetSafe from "../../lib/GetSafe";
import FormatHelper from "../../lib/FormatHelper";
import PHE from "print-html-element";
import { BUILDING_APPLICATION_TYPE } from "../BuildingApplicationTypeTabs";
import { renderToString } from "react-dom/server";
import {
  ClickAwayListener,
  Button,
  Table,
  TableBody,
  TableHead,
} from "@material-ui/core";
import { useMutation } from "urql";
import LinearProgress from "@material-ui/core/LinearProgress";
import { A, navigate } from "hookrouter";
import Typography from "@material-ui/core/Typography";
import { ACL_COMPONENTS, DEFAULT_LOGO_PATH } from "../../config";
import Grid from "@material-ui/core/Grid";
import ExternalErrorLogger from "@ennit/react-external-errorlogger";
import ProjectManagementAddressDataValidator from "../../lib/ProjectManagementAddressDataValidator";

const useStyles = makeStyles((theme) => ({
  airDistance: {
    // backgroundColor: '#e3e3e3',
    padding: 5,
  },
  icon: {
    padding: 8,
    fontSize: 25,
  },
  tableCellColumnsbody: {
    width: "calc(100% * 1 / 5)",
    minWidth: 100,
    padding: 14,
    "&:nth-child(1)": {
      minWidth: 215,
    },
    "&:nth-child(2)": {
      minWidth: 520,
    },
    "&:nth-child(3)": {
      minWidth: 130,
    },
    "@media (max-width:640px)": {
      "&:first-of-type": {
        minWidth: "auto",
      },
      "&:nth-child(2)": {
        minWidth: 320,
      },
    },
  },
  toggleTableRow: {
    borderTop: "2px solid #fff",
  },
  toggleTableCell: {
    paddingTop: 0,
    verticalAlign: "top",
  },
  toggleTableCellMap: {
    paddingLeft: 205,
    "@media (max-width:640px)": {
      paddingLeft: 20,
    },
  },
  toggleTitle: {
    color: "#999",
    fontWeight: "bold",
  },
  newLabel: {
    color: "#BD3A00",
    fontWeight: "bold",
  },
  tooltipItem: {
    width: "100%",
    maxWidth: 350,
    borderRadius: 5,
    background: "#006A7A",
    fontSize: 16,
    textAlign: "center",
    "& div": {
      margin: 0,
      color: "#fff",
    },
  },
  applyTooltipItem: {
    width: "100%",
    maxWidth: 350,
    borderRadius: 5,
    background: "#006A7A",
    fontSize: 16,
    textAlign: "left",
    "& div": {
      margin: 0,
      color: "#fff",
    },
  },
  tooltipInfo: {
    maxWidth: "100%",
    background: theme.palette.background.default,
    "& div": {
      maxWidth: "100%",
      color: theme.palette.text.primary,
      fontSize: 12,
      lineHeight: "20px",
    },
    "@media (min-width:768px)": {
      maxWidth: 450,
    },
  },
  tooltipApprovalDate: {
    "@media (min-width:768px)": {
      maxWidth: 250,
    },
  },
  tooltipTitle: {
    display: "flex",
    alignItems: "center",
  },
  pointer: {
    cursor: "pointer",
  },
  headerWrapper: {
    width: "100%",
    maxWidth: 1320,
    paddingRight: 20,
    paddingLeft: 20,
    backgroundColor: "#4ab3cf",
    "-webkit-print-color-adjust": "exact",
  },
  logo: {
    paddingLeft: 0,
  },
  button: {
    color: "#ffffff",
    width: "60%",
    marginTop: "20px",
    marginBottom: "40px",
  },
}));

const createFavoriteMutation = `
  mutation CreateFavorite (
    $projectHashID: String
  ) {
    createFavorite (ProjectHashID: $projectHashID) {
      HashID
      ProjectHashID
    }
  }
`;

const updateFavoriteMutation = `
  mutation UpdateFavorite (
    $hashID: String,
    $removed: Boolean
  ) {
    updateFavorite (HashID: $hashID, Removed: $removed) {
      HashID
    }
  }
`;

/**
 * ProjectsFreeTableRow
 *
 * @returns {*}
 * @constructor
 */
const ProjectsTableRow = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    upgradeToPremiumOpen,
    setUpgradeToPremiumOpen,
    setMessage,
    token,
    unsetUser,
    unsetToken,
    setFavoriteData,
    user,
  } = useContext(GlobalContext);
  const { row } = props;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const [isInheritedFavorite, setIsInheritedFavorite] = useState(false);
  const [favoriteID, setFavoriteID] = useState(null);
  const [applyTooltipOpen, setApplyTooltipOpen] = useState(false);

  const [{ fetchingCreateFavorite }, executeCreateFavoriteMutation] =
    useMutation(createFavoriteMutation);
  const [{ fetchingUpdateFavorite }, executeUpdateFavoriteMutation] =
    useMutation(updateFavoriteMutation);

  /**
   * mark favorites useEffect
   */
  useEffect(() => {
    if (props.favorites !== null) {
      const result = props.favorites.filter((item) => {
        return item.ProjectHashID === row.HashID;
      });

      if (result.length) {
        setFavoriteID(result[0].HashID);
        if (!result[0].Removed) {
          setIsFavorite(true);
        }

        // Mark inherited favorites
        if (result[0].InheritedByUserID && result[0].InheritedByUserID !== '0') {
            setIsInheritedFavorite(true);
        }
      }
    }
  }, [props.favorites, setIsFavorite, row.HashID]);

  /**
   * open context menu
   *
   * @param event
   */
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  /**
   * close context menu
   */
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  /**
   * handleTooltipClose
   */
  const handleTooltipClose = () => {
    setApplyTooltipOpen(false);
  };

  /**
   * handleTooltipOpen
   */
  const handleTooltipOpen = () => {
    setApplyTooltipOpen(true);
  };

  /**
   * updateFavoriteExecution
   *
   * @param removed
   */
  const updateFavoriteExecution = (removed = true) => {
    executeUpdateFavoriteMutation({
      hashID: favoriteID,
      removed: removed,
    }).then((result) => {
      if (result.error) {
        // Check if the user need to be logged out
        if (result.error.message.indexOf("User forced logout") !== -1) {
          setMessage(MESSAGE_TYPES.ERROR, t("error.user.forced.logout"));
          unsetUser();
          unsetToken();
          navigate("/");
        } else {
          setMessage(MESSAGE_TYPES.ERROR, t("error.save"));
          ExternalErrorLogger.log({
            text: "Error update favorite on ProjectsTableRow",
            data: {
              token: JSON.stringify(token.getData()),
              user: JSON.stringify(user.getData()),
              errorMessage: result.error.message,
            },
          });
        }
      } else {
        setMessage(MESSAGE_TYPES.INFO, t("projects.favorites.updated"));
        setIsFavorite(!removed);
      }
    });
  };

  /**
   * handleMakeFavorite
   */
  const handleMakeFavorite = (event) => {
    event.stopPropagation();
    setFavoriteData([]);
    executeCreateFavoriteMutation({
      projectHashID: row.HashID,
    }).then((result) => {
      if (result.error) {
        // Check if the user need to be logged out
        if (result.error.message.indexOf("User forced logout") !== -1) {
          setMessage(MESSAGE_TYPES.ERROR, t("error.user.forced.logout"));
          unsetUser();
          unsetToken();
          navigate("/");
        } else {
          if (result.error.message.includes("already exists")) {
            updateFavoriteExecution(false);
          } else {
            setMessage(MESSAGE_TYPES.ERROR, t("error.save"));
            ExternalErrorLogger.log({
              text: "Error save new favorite on ProjectsTableRow",
              data: {
                token: JSON.stringify(token.getData()),
                user: JSON.stringify(user.getData()),
                errorMessage: result.error.message,
              },
            });
          }
        }
      } else {
        setMessage(MESSAGE_TYPES.INFO, t("projects.add.to.favorites"));
        setIsFavorite(true);
        setFavoriteID(result.data.createFavorite[0].HashID);
      }
    });
  };

  /**
   * handleRemoveFavorite
   */
  const handleRemoveFavorite = (event) => {
    event.stopPropagation();
    setFavoriteData([]);
    updateFavoriteExecution(true);
  };

  /**
   * handlePrint
   */
  const handlePrint = (event) => {
    event.stopPropagation();
    PHE.printHtml(renderToString(renderPrintAndShare()));
  };

  /**
   * handleShare
   */
  // const handleShare = () => {
  //   const body = `${t('location.label.address')}%3A %0D%0A${GetSafe(
  //     () => row.Construction_site.Address.Street || '',
  //     ''
  //   )} ${GetSafe(
  //     () => row.Construction_site.Address.Number || '',
  //     ''
  //   )}%0D%0A${GetSafe(
  //     () => row.Construction_site.Address.Zip || '',
  //     ''
  //   )} ${GetSafe(
  //     () => row.Construction_site.Address.City || '',
  //     ''
  //   )}%0D%0A%0D%0A${t('projects.label.owner')}%3A%0D%0A${GetSafe(
  //     () => row.Building_owner.Name || '',
  //     ''
  //   )}%0D%0A${GetSafe(
  //     () => row.Building_owner.Address.Street || '',
  //     ''
  //   )} ${GetSafe(
  //     () => row.Building_owner.Address.Number || '',
  //     ''
  //   )}%0D%0A${GetSafe(
  //     () => row.Building_owner.Address.Zip || '',
  //     ''
  //   )} ${GetSafe(
  //     () => row.Building_owner.Address.City || '',
  //     ''
  //   )}%0D%0A%0D%0A${t('projects.label.architect')}%3A%0D%0A${GetSafe(
  //     () => row.Project_management.Name || '',
  //     ''
  //   )}%0D%0A${GetSafe(
  //     () => row.Project_management.Address.Street || '',
  //     ''
  //   )} ${GetSafe(
  //     () => row.Project_management.Address.Number || '',
  //     ''
  //   )}%0D%0A${GetSafe(
  //     () => row.Project_management.Address.Zip || '',
  //     ''
  //   )} ${GetSafe(() => row.Project_management.Address.City || '', '')}
  //   `
  //
  //   window.location.href = `mailto:?to=&body=${body}&subject=${GetSafe(
  //     () => row.Final_title,
  //     ''
  //   )}`
  // }

  /**
   * showDistance
   *
   * @returns {*}
   */
  const showDistance = () => {
    if (row.Distance_calculated_from === "Air_distance") {
      return (
        <Tooltip
          placement="bottom"
          classes={{ tooltip: classes.tooltip }}
          title={t("tooltip.distance.not.calculated")}
          aria-label={t("tooltip.distance.not.calculated")}
          arrow
        >
          <span className={classes.airDistance}>
            {GetSafe(
              () =>
                FormatHelper.formatDistance(row.Calculated_distance) + " km",
              ""
            )}
          </span>
        </Tooltip>
      );
    } else if (
      row.Distance_calculated_from === "Travel_distance" &&
      row.Calculated_distance === null
    ) {
      return (
        <Tooltip
          classes={{ tooltip: classes.tooltip }}
          title={t("tooltip.distance.could.not.be.calculated")}
          aria-label={t("tooltip.distance.could.not.be.calculated")}
          arrow
        >
          <span className={classes.airDistance}>-</span>
        </Tooltip>
      );
    } else if (
      row.Distance_calculated_from !== "Air_distance" &&
      row.Calculated_distance !== null
    ) {
      return GetSafe(
        () => FormatHelper.formatDistance(row.Calculated_distance) + " km",
        ""
      );
    }
  };

  /**
   * getDestinationCoordinates
   *
   * @returns {{lon: *, lat: *}}
   */
  const getDestinationCoordinates = () => {
    return {
      lat: GetSafe(() => parseFloat(row.Construction_site.Address.Geo.lat), 0),
      lon: GetSafe(() => parseFloat(row.Construction_site.Address.Geo.lon), 0),
    };
  };

  /**
   * handleOpenDetailsClick
   */
  const handleOpenDetailsClick = () => {
    setOpen(!open);
  };

  /**
   * isProcessable
   *
   * @param {*} value
   */
  const isProcessable = (value) => {
    return !(value === null || value === undefined);
  };

  /**
   * showApplyButton
   *
   * @returns boolean
   */
  const showApplyButton = () => {
    return user.getData().mode === "smart";
  };

  /**
   * getApplyButtonText
   *
   * @returns string
   */
  const getApplyButtonText = () => {
    return t("general.label.apply");
  };

  /**
   * getApplyButtonTooltipText
   *
   * @returns sting
   */
  const getApplyButtonTooltipText = () => {
    return (
      <>
        <div
          dangerouslySetInnerHTML={{
            __html: t("projects.apply.information").split("\n").join("<br />"),
          }}
        />
        <A href="" onClick={handleUpgradeToPremium}>
          {t("projects.apply.information.link")}
        </A>
      </>
    );
  };

  /**
   * handleUpgradeToPremium
   */
  const handleUpgradeToPremium = () => {
    setApplyTooltipOpen(false);
    setUpgradeToPremiumOpen(!upgradeToPremiumOpen);
  };

  /**
   * renderPrintAndShare
   **/
  const renderPrintAndShare = () => {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerWrapper} colSpan={4}>
              <Grid container justify="space-between">
                <Grid item xs={12} sm="auto">
                  <A href="/" className={classes.logo}>
                    <img src={DEFAULT_LOGO_PATH} alt="logo" />
                  </A>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{GetSafe(() => row.Final_title, "")}</TableCell>
            <TableCell>
              {GetSafe(() => row.Construction_site.Address.City, "")}{" "}
              {GetSafe(() => row.Construction_site.Address.Street, "")}{" "}
              {GetSafe(() => row.Construction_site.Address.Number, "")}
            </TableCell>
            <TableCell>
              {GetSafe(
                () =>
                  FormatHelper.formatDistance(row.Calculated_distance) + " km",
                ""
              )}
            </TableCell>
            <TableCell>
              {GetSafe(() => FormatHelper.formatDate(row.Date), "")}
            </TableCell>
          </TableRow>
          <TableRow id={`project-details-${row.HashID}`}>
            {/* <TableCell> */}
            {/* <p className={classes.toggleTitle}>{t('projects.label.fastest.route')}</p> */}
            {/* <GoogleMapComponent */}
            {/*  origin={getOriginCoordinates()} */}
            {/*  destination={getDestinationCoordinates()} */}
            {/* /> */}
            {/* </TableCell> */}
            <TableCell>
              <p className={classes.toggleTitle}>{t("projects.label.owner")}</p>
              <p>
                {GetSafe(() => row.Building_owner.Name, "")}
                <br />
                {GetSafe(() => row.Building_owner.Address.Street, "")}{" "}
                {GetSafe(() => row.Building_owner.Address.Number, "")}
                <br />
                {GetSafe(() => row.Building_owner.Address.Zip, "")}{" "}
                {GetSafe(() => row.Building_owner.Address.City, "")}
              </p>
            </TableCell>
            <TableCell colSpan={3}>
              <p className={classes.toggleTitle}>
                {t("projects.label.architect")}
              </p>
              <p>
                {GetSafe(() => row.Project_management.Name, "")}
                <br />
                {GetSafe(() => row.Project_management.Address.Street, "")}{" "}
                {GetSafe(() => row.Project_management.Address.Number, "")}
                <br />
                {GetSafe(() => row.Project_management.Address.Zip, "")}{" "}
                {GetSafe(() => row.Project_management.Address.City, "")}
                <br />
                {GetSafe(() => row.Project_management.Phone, "")}
                <br />
                {GetSafe(() => row.Project_management.Email, "")}
              </p>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4}>{row.Content}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  /**
   * renderApprovalDate
   *
   * @returns {false|JSX.Element}
   */
  const renderApprovalDate = () => {
    return (
      row.Approval_date !== undefined &&
      row.Approval_date !== "" &&
      row.Approval_date !== null && (
        <p>
          {user.isPro() && (
            <span>
              <span className={classes.toggleTitle}>
                {t("projects.label.expected.date")}
              </span>
              <span className={classes.tooltipTitle}>{row.Approval_date}</span>
            </span>
          )}
          {!user.isPro() && (
            <span>
              <span className={classes.toggleTitle}>
                {t("projects.label.expected.date")}
              </span>
              <span
                className={clsx(classes.tooltipTitle, classes.pointer)}
                onClick={handleUpgradeToPremium}
              >
                {t("projects.free.route.premium.pro")}
              </span>
            </span>
          )}
        </p>
      )
    );
  };

  /**
   * renderConstructionSum
   *
   * @returns {false|JSX.Element}
   */
  const renderConstructionSum = () => {
    return (
      row.Construction_sum !== undefined &&
      row.Construction_sum !== "" &&
      row.Construction_sum !== null && (
        <p>
          {user.isPro() && (
            <span>
              <span className={classes.toggleTitle}>
                {t("projects.label.construction.sum")}
              </span>
              <span className={classes.tooltipTitle}>
                {row.Construction_sum}
              </span>
            </span>
          )}
          {!user.isPro() && (
            <span>
              <span className={classes.toggleTitle}>
                {t("projects.label.construction.sum")}
              </span>
              <span
                className={clsx(classes.tooltipTitle, classes.pointer)}
                onClick={handleUpgradeToPremium}
              >
                {t("projects.free.route.premium.pro")}
              </span>
            </span>
          )}
        </p>
      )
    );
  };

  /**
   * render the detail view of a project
   */
  const projectDetails = () => {
    return (
      <>
        <TableRow
          id={`project-details-${row.HashID}`}
          className={classes.toggleTableRow}
        >
          <TableCell
            className={clsx(
              classes.toggleTableCell,
              classes.toggleTableCellMap
            )}
            colSpan={2}
          >
            <p className={classes.toggleTitle}>
              {t("projects.label.fastest.route")}
            </p>
            <GoogleMapComponent
              origin={props.originCoordinates}
              destination={getDestinationCoordinates()}
              location={props.location}
            />
          </TableCell>
          <TableCell className={classes.toggleTableCell}>
            <p className={classes.toggleTitle}>{t("projects.label.owner")}</p>
            <p>
              {GetSafe(() => row.Building_owner.Name, "")}
              <br />
              {GetSafe(() => row.Building_owner.Address.Street, "")}{" "}
              {GetSafe(() => row.Building_owner.Address.Number, "")}
              <br />
              {GetSafe(() => row.Building_owner.Address.Zip, "")}{" "}
              {GetSafe(() => row.Building_owner.Address.City, "")}
            </p>
            {renderApprovalDate()}
            {renderConstructionSum()}
            {row.Type !== BUILDING_APPLICATION_TYPE.SUBMISSION ? (
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                title={row.Content}
                PopperProps={{
                  className: clsx(classes.tooltipItem, classes.tooltipInfo),
                }}
              >
                <span className={classes.tooltipTitle}>
                  <Info style={{ fontSize: 30 }} color="primary" />
                  {t("projects.label.original.project")}
                </span>
              </Tooltip>
            ) : null}
          </TableCell>
          <TableCell className={classes.toggleTableCell} colSpan={2}>
            {ProjectManagementAddressDataValidator.isValid(
              row.Project_management.Address
            ) && (
              <span>
                <p className={classes.toggleTitle}>
                  {t("projects.label.architect")}
                </p>
                <p>
                  {GetSafe(() => row.Project_management.Name, "")}
                  <br />
                  {GetSafe(
                    () => row.Project_management.Address.Street,
                    ""
                  )}{" "}
                  {GetSafe(() => row.Project_management.Address.Number, "")}
                  <br />
                  {GetSafe(() => row.Project_management.Address.Zip, "")}{" "}
                  {GetSafe(() => row.Project_management.Address.City, "")}
                  <br />
                  {isProcessable(
                    GetSafe(() => row.Project_management.Phone, "")
                  ) && (
                    <a
                      href={
                        "tel:" + GetSafe(() => row.Project_management.Phone, "")
                      }
                    >
                      {GetSafe(() => row.Project_management.Phone, "")}
                    </a>
                  )}
                  <br />
                  {isProcessable(
                    GetSafe(() => row.Project_management.Email, "")
                  ) && (
                    <a
                      href={
                        "mailto:" +
                        GetSafe(() => row.Project_management.Email, "")
                      }
                    >
                      {GetSafe(() => row.Project_management.Email, "")}
                    </a>
                  )}
                </p>
              </span>
            )}
          </TableCell>
        </TableRow>
        <TableRow className={classes.toggleTableRow}>
          <TableCell colSpan={2} className={classes.toggleTableCell} />
          <TableCell
            colSpan={3}
            className={classes.toggleTableCell}
          ></TableCell>
        </TableRow>
        <TableRow className={classes.toggleTableRow}>
          <TableCell colSpan={3} className={classes.toggleTableCell} />
          <TableCell colSpan={2} className={classes.toggleTableCell}>
            {showApplyButton() && (
              <ClickAwayListener onClickAway={handleTooltipClose}>
                <div>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title={getApplyButtonTooltipText()}
                    PopperProps={{
                      className: clsx(
                        classes.applyTooltipItem,
                        classes.tooltipInfo
                      ),
                      disablePortal: true,
                    }}
                    onClose={handleTooltipClose}
                    open={applyTooltipOpen}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                  >
                    <Button
                      id="buttonApply"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      onClick={handleTooltipOpen}
                    >
                      {getApplyButtonText()}
                    </Button>
                  </Tooltip>
                </div>
              </ClickAwayListener>
            )}
          </TableCell>
        </TableRow>
      </>
    );
  };

  /**
   * return
   */
  return (
    <>
      {(fetchingCreateFavorite || fetchingUpdateFavorite) && <LinearProgress />}
      <TableRow onClick={handleOpenDetailsClick} className={classes.pointer}>
        <TableCell className={classes.tableCellColumnsbody}>
          <IconButton
            id={`project-item-details-toggler-${row.HashID}`}
            onClick={() => setOpen(!open)}
            className={classes.icon}
          >
            {open ? (
              <ExpandLess style={{ fontSize: 30 }} color="primary" />
            ) : (
              <ExpandMore style={{ fontSize: 30 }} color="primary" />
            )}
          </IconButton>
          {isFavorite ? isInheritedFavorite ?
          (
            <Tooltip
              arrow
              classes={{ tooltip: classes.tooltip }}
              title={t("projects.label.inherited.favorite")}
              aria-label={t("projects.label.inherited.favorite")}
            >
                <IconButton
                  id={`project-item-make-favorite-${row.HashID}`}
                  className={classes.icon}
                >
                <Star
                    style={{ fontSize: 30 }}
                    color={!isInheritedFavorite ? "primary" : "disabled"}
                />
                </IconButton>
            </Tooltip>

          ) : (
            <IconButton
              id={`project-item-make-favorite-${row.HashID}`}
              onClick={!isInheritedFavorite ? handleRemoveFavorite : undefined}
              className={classes.icon}
            >
            <Star
                style={{ fontSize: 30 }}
                color={!isInheritedFavorite ? "primary" : "disabled"}
            />
            </IconButton>
          ) : (
            <Tooltip
              arrow
              classes={{ tooltip: classes.tooltip }}
              title={t("projects.label.save.favorite")}
              aria-label={t("projects.label.save.favorite")}
            >
              <IconButton
                id={`project-item-make-favorite-${row.HashID}`}
                onClick={!isInheritedFavorite ? handleMakeFavorite : undefined}
                className={classes.icon}
              >
                <StarBorder
                  style={{ fontSize: 30 }}
                  color={!isInheritedFavorite ? "primary" : "disabled"}
                />
              </IconButton>
            </Tooltip>
          )}
          <IconButton
            aria-controls={`project-menu-${row.HashID}`}
            className={classes.icon}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreHoriz style={{ fontSize: 30 }} color="primary" />
          </IconButton>
          <Menu
            id={`project-menu-${row.HashID}`}
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: {
                marginTop: "42px",
              },
            }}
          >
            <MenuItem
              id={`project-menu-item-${row.HashID}--print`}
              onClick={handlePrint}
            >
              {t("general.label.print")}
            </MenuItem>
          </Menu>
        </TableCell>
        <TableCell
          className={classes.tableCellColumnsbody}
          style={{
            fontSize: 16,
          }}
        >
          {GetSafe(() => row.Final_title, "")}
        </TableCell>
        <TableCell className={classes.tableCellColumnsbody}>
          {GetSafe(() => row.Construction_site.Address.City, "")}{" "}
          {GetSafe(() => row.Construction_site.Address.Street, "")}{" "}
          {GetSafe(() => row.Construction_site.Address.Number, "")}
        </TableCell>
        <TableCell className={classes.tableCellColumnsbody}>
          {showDistance()}
        </TableCell>
        <TableCell className={classes.tableCellColumnsbody}>
          {row.Read !== null ? (
            GetSafe(() => FormatHelper.formatDate(row.Date), "")
          ) : (
            <Typography className={classes.newLabel}>
              {t("general.label.new")}
            </Typography>
          )}
        </TableCell>
      </TableRow>
      {open ? projectDetails() : null}
    </>
  );
};

export default withAccessControl(
  ProjectsTableRow,
  ACL_COMPONENTS.PROJECTS_TABLE_ROW
);
